import styled from 'styled-components';

export const OrderedList = styled.ol`
  font-family: Roboto;
  margin-block-start: 0;
  margin-top: 12px;
  padding-inline-start: 24px;
`;
